const ZoomIn = ({
  className = "stroke-ctb-blue-400"
}: {
  className?: string;
}) => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22.0673 19.0017L15.3722 13.0236M9.79291 5.05279V8.04185M9.79291 8.04185V11.0309M9.79291 8.04185H13.1405M9.79291 8.04185H6.44535M17.6039 8.04185C17.6039 8.95775 17.4018 9.86469 17.0093 10.7109C16.6168 11.557 16.0414 12.3259 15.3161 12.9735C14.5908 13.6212 13.7297 14.1349 12.782 14.4854C11.8344 14.8359 10.8187 15.0163 9.79291 15.0163C8.76716 15.0163 7.75145 14.8359 6.80378 14.4854C5.85611 14.1349 4.99503 13.6212 4.26972 12.9735C3.5444 12.3259 2.96905 11.557 2.57651 10.7109C2.18397 9.86469 1.98193 8.95775 1.98193 8.04185C1.98193 6.19211 2.80487 4.41812 4.26972 3.11016C5.73456 1.80219 7.72131 1.06738 9.79291 1.06738C11.8645 1.06738 13.8513 1.80219 15.3161 3.11016C16.7809 4.41812 17.6039 6.19211 17.6039 8.04185Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ZoomIn;
